import { __assign, __rest } from "tslib";
import React from "react";
import classNames from "classnames";
import { pxTransform } from "@tarojs/taro";
import { View, Image } from "@tarojs/components";
export function Icon(_a) {
    var _b = _a.size, size = _b === void 0 ? 48 : _b, _c = _a.name, name = _c === void 0 ? "" : _c, color = _a.color, className = _a.className, props = __rest(_a, ["size", "name", "color", "className"]);
    // 判断属性 name 的值是否为 url
    var src = name.indexOf("/") !== -1 ? name : null;
    // 生成样式
    var genStyle = function (styleProps) {
        var size = styleProps.size, color = styleProps.color, src = styleProps.src;
        var sizeStyle = src
            ? {
                width: typeof size === "number" ? pxTransform(size, 750) : size,
                height: typeof size === "number" ? pxTransform(size, 750) : size,
            }
            : {
                fontSize: typeof size === "number" ? pxTransform(size, 750) : size,
            };
        var colorStyle = { color: color };
        return __assign(__assign({}, sizeStyle), colorStyle);
    };
    return src ? (React.createElement(View, __assign({ className: classNames("tea-icon", className) }, props),
        React.createElement(Image, { src: src, style: genStyle({ size: size, color: color, src: src }), mode: "aspectFit" }))) : (React.createElement(View, __assign({ className: classNames("tea-icon", "tea-icon-" + name, className), style: genStyle({ size: size, color: color }) }, props)));
}
//# sourceMappingURL=Icon.js.map